<script>
    export let text;
    export let icon;

    let icons = new Map([
        ['exclamation', 'fa-exclamation-circle'],
        ['chart', 'fa-chart-line']
    ]);
</script>

<style>
    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 150px;
    }
    .text {
        font-size: 1.5rem;
        padding: 0 15px;
    }
    .fas {
        
    }
</style>

<div class="container">
    <p class="text">{text}</p>
    <i class={`fas fa-2x ${icons.get(icon) || ""}`}></i>
</div>